import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "button"]
  static values = { copiedLabel: String }

  async copy() {
    const value = this.sourceTarget.value

    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard API unavailable")

      await navigator.clipboard.writeText(value)
    } catch {
      this.sourceTarget.select()
      document.execCommand("copy")
      this.sourceTarget.setSelectionRange(0, 0)
    }

    this.buttonTarget.textContent = this.copiedLabelValue
  }
}
